import React from 'react';
import Clickable from '@prisjakt/ui-clickable';
import * as S from './styles';

type OwnProps = {
  children: React.ReactNode;
};

type ClickableProps = React.ComponentProps<typeof Clickable>;

type Props = OwnProps & ClickableProps;

const TextLink = ({ children, ...props }: Props) => (
  <S.TextLink {...props}>{children}</S.TextLink>
);

export default TextLink;
